"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FeedBackIntent = void 0;
var FeedBackIntent = exports.FeedBackIntent = Object.freeze({
  General: 'general',
  Triggered: 'triggered'
});
var _default = exports["default"] = FeedBackIntent;
//# sourceMappingURL=feedbackIntents.js.map